import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { retainActions } from "../../../../../../_actions";

export default function useGetCampaignSummaryReport({ organizationId, campaignId }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!organizationId || !campaignId) return;
    dispatch(retainActions.getCampaignSummaryReport({ organizationId, campaignId }));
  }, [organizationId, campaignId]);

  const retainMetrics = useSelector((state) => state.retain);

  return {
    loading: retainMetrics.loadingCampaignSummaryReport,
    data: retainMetrics.campaignSummaryReport,
    notFound: retainMetrics.campaignSummaryReportNotFound,
    error: retainMetrics.campaignSummaryReportError,
  };
}

